// Vote type metadata. Each vote type carries a numeric server code and a
// likeVote flag that splits the catalog into positive ("like") and negative
// ("dislike") groupings used by the UI's hover pickers.

export interface DiscussionVoteType {
    name: string;
    code: number;
    likeVote: boolean;
}

export const DISCUSSION_VOTE_TYPES: readonly DiscussionVoteType[] = [
    { name: "LIKE",       code: 0, likeVote: true  },
    { name: "CELEBRATE",  code: 1, likeVote: true  },
    { name: "INSIGHTFUL", code: 2, likeVote: true  },
    { name: "SUPPORT",    code: 3, likeVote: true  },
    { name: "LOVE",       code: 4, likeVote: true  },
    { name: "FUNNY",      code: 5, likeVote: true  },
    { name: "DISLIKE",    code: 6, likeVote: false },
    { name: "DISAGREE",   code: 7, likeVote: false },
    { name: "INCORRECT",  code: 8, likeVote: false },
];

export const LIKE_VOTE_TYPES: readonly DiscussionVoteType[] =
    DISCUSSION_VOTE_TYPES.filter(v => v.likeVote);

export const DISLIKE_VOTE_TYPES: readonly DiscussionVoteType[] =
    DISCUSSION_VOTE_TYPES.filter(v => !v.likeVote);

export function voteTypeByName(name: string): DiscussionVoteType | undefined {
    return DISCUSSION_VOTE_TYPES.find(v => v.name === name);
}
